import { Box, Button, Stack, Typography } from "@mui/material";
import React from "react";
import { useBookingContext } from "../context/BookingContext";
import moment from "moment";
import { useState } from "react";
import { useTranslation } from "react-i18next";

function Zone1() {
  const { data, setOpenZone1, dateUsage, setDateUsage } = useBookingContext();
  const { pickup_date, dropoff_date } = data;
  const { t } = useTranslation();

  const defautValue = dateUsage?.outOfTown?.map((i) => {
    const usageData = {
      date: moment(i?.date).format("YYYY-MM-DD"),
      zone: i.zone || null,
    };
    return usageData;
  });
  const [initData, setInitData] = useState(defautValue || []);

  const startDate = moment(pickup_date, "YYYY-MM-DD");
  const endDate = moment(dropoff_date, "YYYY-MM-DD");

  const datesInRange = [];
  let currentDate = startDate.clone();

  while (currentDate.isBefore(endDate)) {
    datesInRange.push(currentDate.format("YYYY-MM-DD"));
    currentDate.add(1, "days");
  }

  return (
    <Box>
      <Typography fontSize={14} fontWeight="500" mb={1}>
        {t("select_travel_date")}{" "}
      </Typography>
      <Typography>{t("zone_1")}</Typography>
      <Typography color="grey">{t("kerobokan_etc")}</Typography>
      <Box bgcolor="#f7f7f7" my={2} p={1}>
        <Stack direction="row" spacing={{ xs: 1, sm: 2 }}>
          {datesInRange?.map((item, idx) => {
            const day = moment(item).format("ddd");
            const date = moment(item).format("DD");

            const isInOutOfTownDate = initData?.find((val) => val?.date === item);

            const zone2 = initData?.find((val) => val.date === item && val?.zone?.includes(2));

            return (
              <Box
                key={idx}
                sx={{
                  display: "grid",
                  textAlign: "center",
                  gap: { xs: 1, sm: 2 },
                }}
              >
                <Typography color="grey" fontSize={{ xs: 10, sm: 13 }}>
                  {day}
                </Typography>
                <Box
                  onClick={() => {
                    if (!zone2) {
                      let items = [...initData];
                      if (!isInOutOfTownDate) {
                        items.push({ date: item, zone: [1] });
                      } else {
                        items = items.filter((v) => v?.date !== item);
                      }
                      setInitData(items);
                    }
                  }}
                  sx={{
                    backgroundColor: zone2 ? "#ccc" : isInOutOfTownDate ? "#f5272b" : "transparent",
                    color: isInOutOfTownDate ? "#fff" : "#000",
                    fontSize: { xs: 10, sm: 12 },
                    px: { xs: 1, sm: 2 },
                    py: 0.2,
                    fontWeight: "500",
                    cursor: zone2 ? "not-allowed" : "pointer",
                    borderRadius: "2px",
                  }}
                >
                  {date}
                </Box>
                {zone2 ? <span style={{ color: "#ccc", marginTop: -8, fontSize: 8 }}>{t("zone_2")}</span> : <p />}
              </Box>
            );
          })}
        </Stack>
      </Box>
      <Typography size="small">
        {t("total")} : {initData?.length} {t("days")}
      </Typography>
      <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
        <Button
          color="warning"
          onClick={() => {
            setOpenZone1(false);
          }}
        >
          {t("close")}
        </Button>
        <Button
          onClick={() => {
            setDateUsage({ ...dateUsage, outOfTown: initData });
            setOpenZone1(false);
          }}
          variant="contained"
          size="small"
          disableElevation
          disableRipple
          sx={{
            bgcolor: "#f5272b",
            borderRadius: "2px",
            "&:hover": {
              backgroundColor: "#f5272b",
            },
          }}
        >
          {t("save")}
        </Button>
      </Box>
    </Box>
  );
}

export default Zone1;
